 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTML01_TITLE_PAGE from '@/components/xhtml/01_Title_Page'
 import XHTML02_COPYRIGHT from '@/components/xhtml/02_Copyright'
 import XHTML03_DEDICATION from '@/components/xhtml/03_Dedication'
 import XHTML04_EPIGRAPH from '@/components/xhtml/04_Epigraph'
 import XHTML05_CONTENTS from '@/components/xhtml/05_Contents'
 import XHTML06_1__REVOLUTION from '@/components/xhtml/06_1__Revolution'
 import XHTML07_2__LOVE_S_DIMENSIONS from '@/components/xhtml/07_2__Love_s_Dimensions'
 import XHTML08_3__HUMAN_NATURES from '@/components/xhtml/08_3__Human_Natures'
 import XHTML09_4__LITTLE_HEART_SHAPED_PILLS from '@/components/xhtml/09_4__Little_Heart_Shaped_Pills'
 import XHTML10_5__GOOD_ENOUGH_MARRIAGES from '@/components/xhtml/10_5__Good_Enough_Marriages'
 import XHTML11_6__ECSTASY_AS_THERAPY from '@/components/xhtml/11_6__Ecstasy_as_Therapy'
 import XHTML12_7__EVOLVED_FRAGILITY from '@/components/xhtml/12_7__Evolved_Fragility'
 import XHTML13_8__WONDER_HORMONE from '@/components/xhtml/13_8__Wonder_Hormone'
 import XHTML14_9__ANTI_LOVE_DRUGS from '@/components/xhtml/14_9__Anti_love_Drugs'
 import XHTML15_10__CHEMICAL_BREAKUPS from '@/components/xhtml/15_10__Chemical_Breakups'
 import XHTML16_11__AVOIDING_DISASTER from '@/components/xhtml/16_11__Avoiding_Disaster'
 import XHTML17_12__CHOOSING_LOVE from '@/components/xhtml/17_12__Choosing_Love'
 import XHTML18_EPILOGUE__PHARMACOPEIA from '@/components/xhtml/18_Epilogue__Pharmacopeia'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTML19_ACKNOWLEDGMENTS from '@/components/xhtml/19_Acknowledgments'
 import XHTML20_NOTES from '@/components/xhtml/20_Notes'
 import XHTML21_INDEX from '@/components/xhtml/21_Index'
 import XHTML22_ABOUT_THE_AUTHORS from '@/components/xhtml/22_About_the_Authors'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/05_Contents",
 			"name" : "xhtml/05_Contents",
 			"component" : XHTML05_CONTENTS
 		},
 		{
 			"path" : "/xhtml/06_1__Revolution",
 			"name" : "xhtml/06_1__Revolution",
 			"component" : XHTML06_1__REVOLUTION
 		},
 		{
 			"path" : "/xhtml/07_2__Love_s_Dimensions",
 			"name" : "xhtml/07_2__Love_s_Dimensions",
 			"component" : XHTML07_2__LOVE_S_DIMENSIONS
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js